import React from "react";
import { Spinner } from "react-bootstrap";
import { useAuthState } from "react-firebase-hooks/auth";
import { Navigate, useLocation } from "react-router-dom";
import auth from "../../init.firebase";

const PrivateRoute = ({ children }) => {
  const [user, loading, error] = useAuthState(auth);

  const location = useLocation();
  if (loading) {
    return <Spinner animation="border" variant="primary"></Spinner>;
  }
  if (!user) {
    return (
      <Navigate
        to="/account/login"
        state={{ from: location }}
        replace
      ></Navigate>
    );
  }
  return children;
};

export default PrivateRoute;
